document.addEventListener('DOMContentLoaded', () => {
  function initCollapsible() {
    const w = window.innerWidth || document.documentElement.clientWidth;
  if (w > 767) return;

  document.querySelectorAll('p.collapsible').forEach(triggerP => {
    const toToggle = [];
    let node = triggerP.nextElementSibling;
    while (node) {
      toToggle.push(node);
      node = node.nextElementSibling;
    }
    if (toToggle.length === 0) return;

    const ps = toToggle.filter(el => el.tagName === 'P');
    const lastP = ps[ps.length - 1] || triggerP;

    const ellipsis = document.createElement('span');
    ellipsis.className = 'ellipsis';
    ellipsis.textContent = '…';

    const btn = document.createElement('button');
    btn.className = 'toggle-btn';
    btn.textContent = 'more';

    toToggle.forEach(el => el.style.display = 'none');
    triggerP.append(ellipsis, btn);

    let expanded = false;
    btn.addEventListener('click', () => {
      expanded = !expanded;
      toToggle.forEach(el => el.style.display = expanded ? '' : 'none');

      if (expanded) {
        ellipsis.remove();
        lastP.append(btn);
        btn.textContent = 'less';
      } else {
        triggerP.append(ellipsis, btn);
        btn.textContent = 'more';
      }
    });
  });
  }

  initCollapsible();
});